export default __webpack_public_path__ + "static/media/danger.ea01a911.svg";